import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon, PhoneIcon, ZapIcon } from 'lucide-react';
import { PageHeader } from '../components/shared/PageHeader';
import { KindTag } from '../components/shared/KindTag';
import { Reveal } from '../components/shared/Reveal';
import { CtaBand } from '../components/shared/CtaBand';
import { useLanguage } from '../contexts/LanguageContext';
import { business, serviceMeta, type Kind } from '../data/site';
import { useSeo } from '../hooks/useSeo';
import { whatsappLink } from '../utils/whatsapp';
export function Services() {
  const {
    t,
    lang
  } = useLanguage();
  const page = t.services.page;
  useSeo({
    ...t.common.seo.services,
    lang
  });
  return <main data-id="element-570" data-mp="64olwzcyloh0">
      <PageHeader eyebrow={page.eyebrow} title={page.title} description={page.description} data-id="element-571" data-mp="669ggoz9x7ev" />

      <section className="bg-white py-16 sm:py-20" data-id="element-572" data-mp="2cwgybzcj29n4">
        <div className="mx-auto flex max-w-7xl flex-col gap-16 px-5 sm:px-8 lg:gap-24" data-id="element-573" data-mp="2cx8ubba1e9dx">
          {page.categories.map((cat, i) => {
          const meta = serviceMeta.find(m => m.slug === cat.slug);
          const featured = cat.id === 'balloons';
          const reversed = i % 2 === 1;
          return <Reveal key={cat.id} data-id="element-574" data-mp="1fozfk0k7m4q7" data-mpi={i}>
                <article className={`grid items-center gap-8 lg:gap-14 ${featured ? 'lg:grid-cols-[1.25fr_1fr]' : 'lg:grid-cols-2'}`} data-id="element-575" data-mp="1fopqcf6zo1lk">
                  <div className={`overflow-hidden rounded-3xl bg-cream ${reversed ? 'lg:order-2' : ''}`} data-id="element-576" data-mp="1pf2hiq9b6t0o">
                    <img src={meta?.image} alt={cat.title} loading="lazy" className={`w-full object-cover ${featured ? 'aspect-[4/3] lg:aspect-[5/4]' : 'aspect-[4/3]'}`} data-id="element-577" data-mp="1ugi3qln835kn" />
                  </div>
                  <div data-id="element-578" data-mp="51k1qxxi1ihg">
                    <div className="flex flex-wrap items-center gap-2" data-id="element-579" data-mp="90st5w52h49u">
                      <KindTag kind={cat.kind as Kind} label={t.common.kinds[cat.kind as Kind]} tone="dark" data-id="element-580" data-mp="9359y5z398lb" />
                      {featured ? <span className="rounded-full bg-mauve px-2.5 py-1 text-[11px] font-medium text-white" data-id="element-581" data-mp="17donph0xfixa">
                          {page.newBadge}
                        </span> : null}
                    </div>
                    <h2 className={`mt-4 font-display font-semibold leading-tight text-ink ${featured ? 'text-4xl sm:text-5xl' : 'text-3xl sm:text-4xl'}`} data-id="element-582" data-mp="1h9rpglrv9fjp">
                      {cat.title}
                    </h2>
                    <p className="mt-3 text-lg font-medium text-mauve-deep" data-id="element-583" data-mp="252qb6e0lio0y">{cat.price}</p>
                    <ul className="mt-6 space-y-3" data-id="element-584" data-mp="202ccvnosqsg4">
                      {cat.items.map(item => <li key={item} className="flex items-start gap-3 text-[15px] text-ink/80" data-id="element-585" data-mp="2e1lkw02umg90">
                          <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-mauve" aria-hidden="true" data-id="element-586" data-mp="294216kndtb9o" />
                          {item}
                        </li>)}
                    </ul>
                    <Link to={`/services/${cat.slug}`} className="mt-8 inline-flex h-12 items-center gap-2 rounded-full bg-mauve px-6 text-sm font-medium text-white transition-colors duration-150 ease-smooth hover:bg-mauve-deep" data-id="element-587" data-mp="2xkrfxh6mqa2i">
                      {page.explore}
                      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-588" data-mp="2eorme1y06ygt" />
                    </Link>
                  </div>
                </article>
              </Reveal>;
        })}

          <Reveal data-id="element-589" data-mp="24xwxeptdhkro">
            <aside className="grid gap-8 rounded-3xl bg-mauve p-8 text-white sm:p-12 lg:grid-cols-[1.4fr_1fr] lg:items-center" data-id="element-590" data-mp="24zhou6ke4nlb">
              <div data-id="element-591" data-mp="1qzgocs81fi6d">
                <ZapIcon className="h-8 w-8 text-champagne" aria-hidden="true" data-id="element-592" data-mp="1vxs1bbtmq8st" />
                <h2 className="mt-5 font-display text-3xl font-semibold sm:text-4xl" data-id="element-593" data-mp="1vzuo7mzhjltb">{page.sameDay.title}</h2>
                <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-white/85" data-id="element-594" data-mp="1nywtvtafi2px">{page.sameDay.text}</p>
                <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-2" data-id="element-595" data-mp="1e795y2d2z3t7">
                  {page.sameDay.items.map(item => <li key={item} className="flex items-center gap-2 text-sm" data-id="element-596" data-mp="1a6gx3a84f0xg">
                      <CheckIcon className="h-4 w-4 text-champagne" aria-hidden="true" data-id="element-597" data-mp="156b2bl6k0yb5" />
                      {item}
                    </li>)}
                </ul>
              </div>
              <div className="flex flex-col gap-3" data-id="element-598" data-mp="v84z9090hm4p">
                <a href={business.phoneHref} className="flex h-14 items-center justify-center gap-2 rounded-full bg-white text-sm font-medium text-mauve-deep transition-colors duration-150 ease-smooth hover:bg-petal" data-id="element-599" data-mp="v8wto7qvhdte">
                  <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-600" data-mp="2llvsi9kolkqg" />
                  {page.sameDay.call}
                </a>
                <a href={whatsappLink()} target="_blank" rel="noreferrer" className="flex h-14 items-center justify-center rounded-full border border-white/40 text-sm font-medium text-white transition-colors duration-150 ease-smooth hover:bg-white/10" data-id="element-601" data-mp="7ct8yq5dxfv7">
                  {page.sameDay.whatsapp}
                </a>
              </div>
            </aside>
          </Reveal>
        </div>
      </section>

      <CtaBand data-id="element-602" data-mp="3pj7xtk56za8d" />
    </main>;
}